import {Injectable} from '@angular/core';
import {DialogService} from 'src/app/services/dialog.service';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  private fileInstance = null;
  private fileSizeLimit = 1024 * 1024; // 1 MB

  constructor(private dialogService: DialogService) {
  }

  set file(fileToBeUsed: any) {
    this.fileInstance = fileToBeUsed;
  }

  get file(): any {
    return this.fileInstance;
  }

  public getFleSizeLimit(): any {
    return this.fileSizeLimit;
  }

  importFile(event, callback, options, limit = 20) {
    if (event.target.files.length === 0) {
      return;
    }
    this.file = event.target.files[0];
    const fileLimit = limit * this.fileSizeLimit;
    if (this.file.size > fileLimit) {
      this.dialogService.openAlertDialog(
        '350px',
        'we do not support file size more than ' + limit + 'MB as of today. Please try again with file size within limit.',
        'ERROR',
        'Ok',
        'modal-warning'
      );
      return;
    }
    callback(options);
  }
}
